import { MultiFieldImageSource } from './multi-field-image-source';

export class MultiFieldContent {
	key: string;
	textContent?: string;
	imageContent?: string;
	fileName?: string;
	imageWidth?: number;
	imageHeight?: number;
	imageSource: MultiFieldImageSource = MultiFieldImageSource.None;
	galleryImageId?: string;

	constructor(key: string) {
		this.key = key;
	}
}
